// @flow
import styled from 'styled-components';

import { px, py } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';

export const StyledCover = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledError = styled.span`
  color: pink;

  ${px(3.5)}
  ${py(2)}

  ${breakpoint('desktop')`
    ${px(0)}
    color: red;
  `}
`;
